// extracted by mini-css-extract-plugin
export default {"modal":"cancel-subscription_modal__dTROH","bold":"cancel-subscription_bold__6d3MM"};